<template>
  <a-card :bordered="false">
    <search-page-view
      ref="table"
      rowKey="proId"
      :itemNames="['search_proId','search_proName','create_button',]"
      :columns="getColumns()"
      :enableSearch="false"
      :queryParams="queryParams"
      :requestPromise="loadPromise"
    >
      <a-form-item slot="search_proId" style="margin-right: 10px">
        <a-input v-model="queryParams.orderNo" placeholder="关联销售订单号"></a-input>
      </a-form-item>
      <a-form-item slot="search_proName">
        <a-input v-model="queryParams.supplerOrderNo" placeholder="长隆订单号"></a-input>
      </a-form-item>
      <a-form-item slot="create_button">
        <a-button style="margin-left:15px" type="primary" @click="$refs.table.refresh(true)">查 询</a-button>
      </a-form-item>
      <template slot="userSlot" slot-scope="rowItem">
        <div>{{ rowItem.record.contactName }}</div>
        <div>{{ rowItem.record.phone }}</div>
      </template>
    </search-page-view>
  </a-card>
</template>

<script>
import ChimelongTicketMixins from './ChimelongTicketMixins'

export default {
  name: 'ChimelongOrderConnection',
  mixins: [ChimelongTicketMixins],
  data() {
    return {
      queryParams: {
        orderNo: '',
        supplerOrderNo: '',
        orderType: 20
      },
      loadPromise: params => this.getListPromise(params)
    }
  },
  mounted() {

  },
  methods: {
    // 获取表格数据接口
    getListPromise(params) {
      this.getLogUtils().logWithTag('==getListPromise==', params)
      return this.getHttpServices().getOrderService().post('direct/getDirectOrderPage', params)
    },
    getColumns() {
      return [
        {
          title: '长隆订单ID',
          dataIndex: 'supplerOrderNo',
          width: '12%'
        },
        {
          title: '关联销售订单号',
          dataIndex: 'orderNo',
          width: '12%'
        },
        {
          title: '商品名称',
          dataIndex: 'proName',
          width: '20%'
        },
        {
          title: '下单用户',
          dataIndex: 'contactName',
          scopedSlots: { customRender: 'userSlot' }
        },
        {
          title: '订单来源',
          dataIndex: 'sourceStr'
        },
        {
          title: '订单状态',
          dataIndex: 'statusStr'
        },
        {
          title: '供应商名称',
          dataIndex: 'accountName'
        },
        {
          title: '下单时间',
          dataIndex: 'createTime'
        }
      ]
    }
  }
}
</script>
<style scoped></style>
